<template>
  <div class="news-list">
    <div class="news-item fs" v-for="(item, key) in newsList" :key="key" @click="toDetail(key)">
      <img :src="item.url" />
      <div class="content">
        <div class="title">{{ item.title }}</div>
        <div class="text" v-html="item.content[0]"></div>
        <div class="time">{{ item.subTitle }}</div>
      </div>
    </div>
    <div class="fc" v-if="props.showMore">
      <div class="more-btn fc" @click="showMore">{{ $t('homePage.moreNews') }}<RightOutlined class="more_ico" /></div>
    </div>
  </div>
</template>

<script setup>
import newsData from '@/assets/json/news'
import { useRouter } from 'vue-router';
import { RightOutlined } from '@ant-design/icons-vue'
import { computed } from "vue";
import { defineProps } from 'vue';

const router = useRouter()

const props = defineProps({
  showMore: {
    type: Boolean,
    default: false
  },
  limit: {
    type: Boolean,
    default: false
  }
});

const newsList = computed(() => {
  const arr  = Object.keys(newsData);
  const keys = arr.slice(0, props.limit ? 3 : arr.length); // 获取前三个键
  const result = keys.reduce((acc, key) => {
    acc[key] = newsData[key]; // 使用这些键来构造新的对象
    return acc;
  }, {});
 
  return result
});

const showMore = () => {
  router.push({
    path: '/news_center/list'
  })
}

const toDetail = (key) => {
  router.push({
    path: '/news_center/detail',
    query: {
      id: key
    }
  })
}
</script>

<style lang="less" scoped>
.news-list {
  .news-item {
    padding-bottom: 25px;
    margin-bottom: 25px;
    border-bottom: solid 1px #ECECEC;
    img {
      width: 180px;
      height: 180px;
      border-radius: 8px;
      margin-right: 40px;
      cursor: pointer;
    }
    .content {
      cursor: pointer;
      .title {
        font-size: 18px;
        line-height: 40px;
        color: #1C1F35;
      }
      .text {
        font-size: 14px;
        line-height: 180%;
        color: #666C89;
        margin-bottom: 49px;
      }
      .time {
        color: 14px;
        line-height: 140%;
        color: #666C89;
      }
    }
  }
  .more-btn {
    width: 100px;
    height: 40px;
    background-color: #F9F9F9;
    font-size: 14px;
    color: #323B46;
    border: solid 1px #B8B8B8;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 27px;
    .more_ico {
      font-size: 10px;
      margin-left: 2px;
    }
  }
}
</style>